"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./TrialSpecifics.scss");
var _CTASection = _interopRequireDefault(require("../../CTASection/CTASection"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TrialSpecifics = _ref => {
  let {
    content
  } = _ref;
  const {
    header,
    text,
    signInText,
    ctas
  } = content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "trial-specifics"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "trial-specifics--top"
  }, header && /*#__PURE__*/_react.default.createElement("h2", {
    className: "trial-specifics--top--header"
  }, header), text && /*#__PURE__*/_react.default.createElement("h4", {
    className: "trial-specifics--top--text"
  }, text)), /*#__PURE__*/_react.default.createElement("div", {
    className: "trial-specifics--bottom"
  }, signInText && /*#__PURE__*/_react.default.createElement("p", {
    className: "trial-specifics--bottom--text"
  }, signInText), ctas && /*#__PURE__*/_react.default.createElement(_CTASection.default, {
    ctas: ctas
  })));
};
var _default = TrialSpecifics;
exports.default = _default;